import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import parser from 'query-string'
import usePricing from '../../redux/pricing/usePricing'
import { AppState } from '../../redux/root-reducer'
import { AffiliateTrackState } from '../../redux/affiliate-track/types'
import { useSubscriptions } from '../Auth'

const usePlanQuery = () => {
  const { pricing } = usePricing()
  const { affiliate } = useSelector<AppState, AffiliateTrackState>((state) => state.affiliate)
  const { subscriptions } = useSubscriptions(!!affiliate)

  // grab the plan from the URL ('Month' | 'Year' | 'Trial' | 'Challenge')
  const { search } = useLocation()
  const { plan } = parser.parse(search)

  const [matchedSubscription, setMatchedSubscription] = useState<typeof subscriptions[0] | null>(
    null
  )

  // expose the subscription based on the plan that is found in the URL
  useEffect(() => {
    const matchingPlan = subscriptions.find((sub) => sub.id === plan)
    setMatchedSubscription(matchingPlan || null)
  }, [pricing, plan])

  return { matchedSubscription }
}

export default usePlanQuery
